/**
 * Рейтинг вместе со своими запросами.
 *
 * Отдельным файлом, а не веткой роутера: у экрана два хука с запросами к
 * серверу, а хук нельзя вызывать внутри ветки `switch` — правило React о
 * порядке вызовов. Роутер при этом остаётся списком экранов, а не местом,
 * где живут запросы.
 */

import type { Translate } from '@type2x/i18n';

import type { Runtime } from '../runtime.js';
import { useFriends } from '../state/friends.js';
import { useLeaderboard } from '../state/leaderboard.js';
import { LeaderboardScreen } from './LeaderboardScreen.js';

export interface LeaderboardRouteProps {
  readonly runtime: Runtime;
  readonly t: Translate;
  readonly language: string;
  readonly onSaveProgress: () => void;
  readonly onBack: () => void;
}

export function LeaderboardRoute({
  runtime,
  t,
  language,
  onSaveProgress,
  onBack,
}: LeaderboardRouteProps): React.JSX.Element {
  const leaderboard = useLeaderboard(runtime, language);
  const friends = useFriends(runtime, language);

  return (
    <LeaderboardScreen
      t={t}
      leaderboard={leaderboard}
      friends={friends}
      invite={runtime.friendInvite}
      onSaveProgress={onSaveProgress}
      onBack={onBack}
    />
  );
}
